import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useContext, useRef, useState } from "react";
import { UsersContext } from "../context/UserContextProvider";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { UserNameEditForm } from "./UserNameEditForm";
import { usersApi } from "../../../services/api";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { PostUser, User } from "../types";

export function EditUserNameModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  CurrentUser: User | PostUser;
  onMount: () => void;
}) {
  const { setUser } = useContext(UsersContext);

  const { open, setOpen, CurrentUser, onMount } = props;
  const [newName, setNewName] = useState<string>("");
  const [openEditConfirmationModal, setOpenEditConfirmationModal] =
    useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const userId = CurrentUser && "id" in CurrentUser ? CurrentUser.id : "";
  const onClose = () => setOpen(false);

  const formRef = useRef<HTMLFormElement | null>(null);
  const handleFormSubmit = async () => {
    if (formRef.current) formRef.current.submitForm();
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          <Typography
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
              },
              fontWeight: 500,
            }}
          >
            Editar Nome do Usuário
          </Typography>
        </DialogHeader>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "auto",
            width: "450px",
            height: "100%",
          }}
          dividers
        >
          <UserNameEditForm
            open={open}
            user={CurrentUser}
            setCanEdit={setCanEdit}
            setNewName={setNewName}
            setOpenConfirmNameEditModal={setOpenEditConfirmationModal}
            ref={formRef}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Fechar</Button>
          <Button
            disabled={!canEdit}
            variant="contained"
            color="primary"
            onClick={handleFormSubmit}
          >
            Editar Nome
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmationModal
        open={openEditConfirmationModal}
        setOpen={setOpenEditConfirmationModal}
        title="Editar Nome do Usuário"
        contentText="Deseja confirmar a edição do nome do usuário?"
        onConfirm={async () => {
          await usersApi.patchUserName(userId, newName);
          const updatedUser = await usersApi.getUser(userId);
          setUser(updatedUser);
          onMount();
        }}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <ActionAlert
        message="O nome do Usuário foi editado com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        onClose={() => {
          setOpen(false);
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao editar o nome do Usuário, tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}
